import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import CheckboxInput from 'components/Credit24/Core/Controls/CheckboxInput';
import AccordionTooltip from 'components/common/controls/AccordionTooltip';

const propTypes = {
  consents: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  isThirdPartyDisabled: PropTypes.bool,
};

const MarketingConsentsGroup = ({ disabled, consents, isThirdPartyDisabled }) => (
  <div className="fieldset">
    {COUNTRY === 'FI' && <FormattedMessage id="signup.field.consent.intro" tagName="p" />}
    {consents.map(({ consentName, showFullText }) => (
      <div className="checkbox-section" key={consentName}>
        <div className="checkbox-section__control">
          <Field
            name={consentName}
            component={CheckboxInput}
            text={(
              <FormattedHTMLMessage
                id={`signup.field.consent.${consentName}.short`}
              />
            )}
            disabled={disabled || (consentName === 'MARKETING_3RD_PARTY' && isThirdPartyDisabled)}
            isErrorVisible
          />
        </div>
        {!showFullText
          && (
          <div className="checkbox-section__content">
            <AccordionTooltip
              title={<FormattedMessage id="signup.field.consent.readmore" />}
            >
              <FormattedHTMLMessage id={`signup.field.consent.${consentName}.long`} />
            </AccordionTooltip>
          </div>
          )}
      </div>
    ))}
  </div>
);

MarketingConsentsGroup.propTypes = propTypes;

export default MarketingConsentsGroup;
